// Subtle futuristic UI sounds via Web Audio. Unlocked on first user gesture (autoplay policy).
let ctx = null;
let lastHover = 0;

function ensure() {
  if (typeof window === "undefined") return null;
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

if (typeof window !== "undefined") {
  window.addEventListener("pointerdown", () => ensure(), { once: true });
}

export function hoverSfx() {
  const c = ensure();
  if (!c || c.state !== "running") return;
  const now = performance.now();
  if (now - lastHover < 45) return;
  lastHover = now;
  const t = c.currentTime;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = "triangle";
  o.frequency.setValueAtTime(1500, t);
  o.frequency.exponentialRampToValueAtTime(2100, t + 0.05);
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(0.025, t + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, t + 0.09);
  o.connect(g); g.connect(c.destination);
  o.start(t); o.stop(t + 0.1);
}

export function clickSfx() {
  const c = ensure();
  if (!c || c.state !== "running") return;
  const t = c.currentTime;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = "square";
  o.frequency.setValueAtTime(660, t);
  o.frequency.exponentialRampToValueAtTime(1300, t + 0.08);
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(0.035, t + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, t + 0.12);
  o.connect(g); g.connect(c.destination);
  o.start(t); o.stop(t + 0.13);
}
